// https://facebook.github.io/react/tips/dangerously-set-inner-html.html
export default function createMarkup(html) {
  return {
    __html: html,
  };
}
